<div class="pt-m">
    <app-power-bi reportId="MAIN_DASHBOARD" ratio="44.4444444444" ></app-power-bi>
</div>

